<toast-notification></toast-notification>
<get-screen-size></get-screen-size>

<div
  *ngIf="!isLoading"
  class="p-d-flex p-jc-center align-items-center justify-content-center login-container"
>
  <div [style]="bodySize">
    <div class="surface-img p-d-flex p-jc-center w-full p-mb-4 text-center">
      <img
        width="280"
        src="../../../assets/images/scalableVectorGraphics/logo-full.svg"
        alt="Image"
        class="mt-4 mx-auto"
      />
    </div>

    <app-subscriber-user
      (handleLogin)="login($event)"
      [screenSize]="screenSize"
    ></app-subscriber-user>
  </div>
</div>

<div *ngIf="isLoading">
  <app-spinner alwaysVisible="true"></app-spinner>
</div>
